import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useProductDetailSafe } from '../../context/product-detail-context'
import { ProductPromotionItem } from './product-item'

export const ProductPromotion = () => {
  const { product } = useProductDetailSafe()
  const t = useTranslations('product_detail.title')

  const promotionActive = product?.promotions?.filter(
    (promotion) => promotion.show_in_detail
  )

  if (!promotionActive || promotionActive.length === 0) {
    return null
  }

  return (
    <div
      data-label='product-promotion'
      className='relative mx-auto w-full overflow-hidden rounded-[8px] border border-[#273BCD] md:mb-4 lg:mb-6'
    >
      {/* Header */}
      <div className='flex w-full items-center bg-gradient-to-r from-[#273BCD] to-[#5A74F2] px-4 py-2.5 text-white'>
        <div className='font-sans text-sm font-medium'>
          {t('special_offer_just_for_you')}
        </div>
      </div>

      <Carousel
        opts={{
          align: 'start',
          duration: 50,
          skipSnaps: false,
        }}
        className='w-full'
      >
        <CarouselContent className='ml-0 gap-2.5 p-3'>
          {promotionActive?.map((promotion) => (
            <CarouselItem
              key={promotion.id}
              className='basis-[160px] pl-0'
              data-product-id={promotion.id}
            >
              <ProductPromotionItem product={promotion} />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  )
}

const CarouselNavigation = () => {
  return (
    <div className='absolute -top-5 right-14'>
      <div className='relative'>
        <CarouselPrevious
          className='absolute left-0 h-5 w-5'
          variant='black'
          hideIfStart
        />
        <CarouselNext className='absolute h-5 w-5' variant='black' hideIfEnd />
      </div>
    </div>
  )
}
